import { IsoModelSectionProps } from "@/src/sections/banner-model/Iso";

export const isoSectionData: IsoModelSectionProps = {
   cards: [
      {
         img: "/assets/images/iso/blue/1.png"
      },
      {
         img: "/assets/images/iso/blue/2.png"
      },
      {
         img: "/assets/images/iso/blue/3.png"
      },
      {
         img: "/assets/images/iso/blue/4.png"
      },
      {
         img: "/assets/images/iso/blue/5.png"
      },
      {
         img: "/assets/images/iso/blue/6.png"
      },
      {
         img: "/assets/images/iso/blue/7.png"
      },
      {
         img: "/assets/images/iso/blue/8.png"
      },
      {
         img: "/assets/images/iso/blue/9.png"
      },
      {
         img: "/assets/images/iso/blue/10.png"
      },
      {
         img: "/assets/images/iso/blue/11.png"
      },
      {
         img: "/assets/images/iso/blue/12.png"
      },
      {
         img: "/assets/images/iso/blue/13.png"
      },
      {
         img: "/assets/images/iso/blue/14.png"
      },
      {
         img: "/assets/images/iso/blue/15.png"
      },
      {
         img: "/assets/images/iso/blue/16.png"
      },
      {
         img: "/assets/images/iso/blue/17.png"
      },
      {
         img: "/assets/images/iso/blue/18.png"
      },
      {
         img: "/assets/images/iso/blue/19.png"
      },
      {
         img: "/assets/images/iso/blue/20.png"
      },
      {
         img: "/assets/images/iso/blue/21.png"
      },
      {
         img: "/assets/images/iso/blue/22.png"
      },
      {
         img: "/assets/images/iso/blue/23.png"
      },
      {
         img: "/assets/images/iso/blue/24.png"
      },
      {
         img: "/assets/images/iso/blue/25.png"
      },
      {
         img: "/assets/images/iso/blue/26.png"
      },
      {
         img: "/assets/images/iso/blue/27.png"
      },
   ],
};